import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import LineExclamationTriangleIcon from 'LuxKit/Icons/line/LineExclamationTriangleIcon'
import { useAppSelector } from 'hooks/reduxHooks'
import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'

function useLuxPlusWarningItem(): PageBannerCarouselItem | null {
  const intl = useIntl()
  const hasError = useAppSelector(state => !!state.auth.account.luxPlus.member.subscription.error)

  return useMemo(() => {
    if (!hasError) return null

    return {
      id: 'luxplus-warning',
      kind: 'warning' as const,
      icon: <LineExclamationTriangleIcon />,
      children: intl.formatMessage(
        {
          id: 'TZjA506Cg6q-Zen4xixA',
          defaultMessage: 'We are currently experiencing issues with your {programName} membership. Our team is on it. Please check back later.',
          description: 'Warning banner message when there are issues with LuxPlus membership',
        },
        { programName: LUXURY_PLUS.PROGRAM_NAME },
      ),
    }
  }, [hasError, intl])
}

export default useLuxPlusWarningItem
